import { render } from "./NavbarCircleButtonColor.vue?vue&type=template&id=79081bef&scoped=true"
import script from "./NavbarCircleButtonColor.vue?vue&type=script&lang=js"
export * from "./NavbarCircleButtonColor.vue?vue&type=script&lang=js"

import "./NavbarCircleButtonColor.vue?vue&type=style&index=0&id=79081bef&scoped=true&lang=scss"

import exportComponent from "/Users/vladimirkurockin/Projects/NowMedia/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79081bef"]])

export default __exports__